const getLocale = (): string =>
  typeof navigator !== "undefined" && navigator.language
    ? navigator.language
    : "en-US";

export const formatDate = (iso: string | null | undefined): string => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString(getLocale(), {
      dateStyle: "short",
      timeStyle: "short",
    });
  } catch {
    return iso;
  }
};

export const formatNumber = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return "—";
  return value.toLocaleString("en-US").replace(/,/g, " ");
};
